import { axiosInstance } from "../../../../config/api/Axios";

export const updateStackApi = (stack_id, stackData) => axiosInstance.put(`/lab/stacks/${stack_id}`, stackData);
